import { NetworkAccountAvatarProps } from '#/interfaces/NetworkAccountAvatarProps';
// @ts-ignore
import { polkadotIcon } from '@polkadot/ui-shared/icons/polkadot';
import { useMemo } from 'react';

export default function PolkadotAccountAvatar({
  address,
  diameter = 24,
  ...props
}: NetworkAccountAvatarProps) {
  const circles = useMemo(
    () => (address ? polkadotIcon(address, { isAlternative: false }) : null),
    [address]
  );
  return (
    <div {...props}>
      <svg height={diameter} viewBox="0 0 64 64" width={diameter}>
        {
          // @ts-ignore
          circles?.map((circle, i) => (
            <circle
              key={i}
              cx={circle.cx}
              cy={circle.cy}
              fill={circle.fill}
              r={circle.r}
            />
          ))
        }
      </svg>
    </div>
  );
}
